import React from "react"

import {
  prefetchPartnersBankingDetailsApprovalRetrieveQuery,
  prefetchPartnersBankingDetailsRetrieveQuery,
  usePartnersBankingDetailsApprovalRetrieve,
} from "@boundless/bl-api-client/partners/services"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { ApprovalStatusAlert } from "@/components/approvals/ApprovalStatusAlert"
import {
  BankingDetailsForm,
  FallbackBankingDetailsForm,
} from "@/components/partners/BankingDetailsForm"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export const Route = createFileRoute("/_dashboard/partners/banking")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["partners.view_bankingdetails"])) {
      throw redirect({ to: "/" })
    }
  },
  loader: ({ context: { queryClient } }) => {
    prefetchPartnersBankingDetailsRetrieveQuery(queryClient)
    prefetchPartnersBankingDetailsApprovalRetrieveQuery(queryClient)
  },
})

function RouteComponent() {
  const { data: approval } = usePartnersBankingDetailsApprovalRetrieve()

  return (
    <div className="@container">
      <div className="grid grid-cols-1 @md:grid-cols-3">
        <Card className="@md:col-span-2">
          <CardHeader>
            <CardTitle>Banking Details</CardTitle>
            <CardDescription>
              Please complete your banking details below to receive commission
              payouts
            </CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-6">
            {approval && <ApprovalStatusAlert approval={approval} />}
            <React.Suspense fallback={<FallbackBankingDetailsForm />}>
              <BankingDetailsForm />
            </React.Suspense>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
